module.exports = __webpack_public_path__ + "img/3022931.6bee4794.svg";